var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFavSelected = function SvgFavSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.246 11.206a8 8 0 0 1 8 8v47.863a1 1 0 0 1-1.571.82l-20.08-13.983a1 1 0 0 0-1.143 0L19.373 67.889a1 1 0 0 1-1.571-.82V19.206a8 8 0 0 1 8-8h28.444Z",
    fill: "url(#fav-selected_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.648 26.547v-.012c-.835-2.41-3.08-4.035-5.583-4.035-2.166 0-4.038 1.21-5.076 2.986-1.038-1.775-2.91-2.986-5.076-2.986-2.504-.012-4.749 1.614-5.583 4.024v.011c-2.47 7.667 9.734 14.573 10.264 14.861a.851.851 0 0 0 .812 0c.52-.288 12.735-7.194 10.265-14.86l-.023.01Z",
    fill: "url(#fav-selected_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fav-selected_svg__a",
    x1: 15.562,
    y1: 48.701,
    x2: 64.451,
    y2: 48.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7241",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#FF7241",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F85C26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fav-selected_svg__b",
    x1: 40,
    y1: 22.5,
    x2: 40,
    y2: 41.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })))));
};
export default SvgFavSelected;